/* tslint:disable:jsx-no-lambda WI:47691 */
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import { IImageProps } from 'office-ui-fabric-react/lib/Image';
import {
    EVENTS,
    teachingUITrace,
    logTeachingEvent,
} from '../utils/actionableMessagesTeachingUIUtils';
import { trace } from 'owa-trace';

const TEACHINGUI_TYPE = 'TeachingBubble';

type DismissedAction = 'Primary' | 'Secondary';

export interface ActionableMessageTeachingBubbleProps extends LightningProps {
    target: () => HTMLElement;
    gotItBtn: IButtonProps; //'I got it' button props
    learnMoreBtn?: IButtonProps; //'Learn more' button props
    learnMoreBtnUri?: string; //'Learn more' button onClick uri
    illustrationImage?: IImageProps; //optional image
    headline: string; //headline string
    bodyText: string; //body string
    hasSmallHeadline?: boolean;
    hasSmallIcon?: boolean;
    hasCloseIcon?: boolean;
    isWide?: boolean;
    onClose?: any;
}

export const ActionableMessageTeachingBubble = lightable(
    observer(function ActionableMessageTeachingBubble(props: ActionableMessageTeachingBubbleProps) {
        props = {
            hasSmallIcon: true,
            hasSmallHeadline: true,
            hasCloseIcon: true,
            isWide: true,
            ...props,
        };

        const [showTeachingBubble, setShowTeachingBubble] = React.useState(true);
        React.useEffect(() => {
            trace.info('[ActionableMessageTeachingUI:TeachingBubble] Teaching Bubble DidMount');
            logTeachingEvent(`${TEACHINGUI_TYPE}_${EVENTS.SCOPE.MOUNTED}`, teachingUITrace());

            return () => {
                trace.info(
                    '[ActionableMessageTeachingUI:TeachingBubble] Teaching Bubble WillUnmountMount'
                );
                logTeachingEvent(`${TEACHINGUI_TYPE}_${EVENTS.SCOPE.UNMNTED}`, teachingUITrace());
            };
        }, []);

        const onClose = (actionTaken: DismissedAction = 'Primary') => {
            if (actionTaken == 'Secondary') {
                trace.info(
                    '[ActionableMessageTeachingUI:TeachingBubble] teacing bubble dismissed by user interaction'
                );
                logTeachingEvent(
                    `${TEACHINGUI_TYPE}_${EVENTS.CLICK}`,
                    teachingUITrace({ lightningAction: actionTaken })
                );
            } else {
                trace.info(
                    '[ActionableMessageTeachingUI:TeachingBubble] teaching bubble passively dismissed'
                );
                logTeachingEvent(
                    `${TEACHINGUI_TYPE}_${EVENTS.DISMISSED.UNMNT}`,
                    teachingUITrace({ lightningAction: actionTaken })
                );
            }

            lighted(props.lid, actionTaken);

            //makes sure the element is hidden
            setShowTeachingBubble(false);
        };

        if (showTeachingBubble) {
            trace.info(
                '[ActionableMessageTeachingUI:TeachingBubble] Using TeachingBubble for ActionableMessageTeachingUI'
            );
            logTeachingEvent(`${TEACHINGUI_TYPE}_${EVENTS.RENDERED}`, teachingUITrace());
        }

        return (
            showTeachingBubble && (
                <TeachingBubble
                    calloutProps={{
                        beakWidth: 15,
                        directionalHint: DirectionalHint.leftCenter,
                        minPagePadding: 50,
                    }}
                    targetElement={props.target()}
                    primaryButtonProps={{
                        ...props.gotItBtn,
                        onClick: () => {
                            logTeachingEvent(
                                `${TEACHINGUI_TYPE}_${EVENTS.GOTITCUSTOM}`,
                                teachingUITrace({ lightningAction: 'Secondary' })
                            );
                            onClose('Secondary');
                        },
                    }}
                    secondaryButtonProps={{
                        ...props.learnMoreBtn,
                        onClick: () => {
                            logTeachingEvent(
                                `${TEACHINGUI_TYPE}_${EVENTS.LEARN}`,
                                teachingUITrace({ lightningAction: 'Secondary' })
                            );
                            window.open(props.learnMoreBtnUri, '_blank');
                            onClose('Secondary');
                        },
                    }}
                    onDismiss={() => props.onClose || onClose('Primary')} //sence we do not care about falsy values here...
                    {...props}
                    target={undefined}>
                    {props.bodyText}
                </TeachingBubble>
            )
        );
    })
);
